import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';

import { CustomDropdown } from '../../../../../common/custom-form/custom-dropdown.component';
import { SelectFieldFloatingLabel } from '../../../../../common/custom-form/select-filter.component';
import { hrDetailsActions } from '../../../../../../store/external/manage-user/form/manage-user-form.reducer';

class ApproverDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: true
        }
    }

    handleToggle = () =>{
        this.setState(prev => ({isCollapsed: !prev.isCollapsed}))
    }

    render() {
        const {isCollapsed} = this.state;
        const { translator, manageUserHrDetails, manageUserHrDetailsForm } = this.props;
        return (
            <div className="control-container">
                
            <CustomDropdown activeDropdown={isCollapsed} toggleActiveState={() => {this.handleToggle()}} label={translator("approver_details")} >
                <div className={`add-sim-container detail-page-container details-4-col-container`}>
                    <SelectFieldFloatingLabel
                        className="form-select no-select__option"
                        label={translator('cost_center_authorizer')}
                        options={manageUserHrDetails.approverCostCenterAuthorizerDropdown}
                        value={`${manageUserHrDetailsForm.approverCostCenterAuthorizer}` ?? ""}
                        placeholder={translator('select_placeholder')}
                        fieldProp='manageUserHrDetailsForm.approverCostCenterAuthorizer'
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                    />
                    <SelectFieldFloatingLabel
                        className="form-select no-select__option"
                        label={translator('wireline_approver')}
                        options={manageUserHrDetails.approverWirelineDropdown}
                        value={`${manageUserHrDetailsForm.approverWireline}` ?? ""}
                        placeholder={translator('select_placeholder')}
                        fieldProp='manageUserHrDetailsForm.approverWireline'
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                    /> 
                </div>
            </CustomDropdown>
        </div>
        );
    }
}


export default connect(
    state => {
        const { manageUserHrDetails, translation } = state;
        const { manageUserHrDetailsForm } = state.form;

        return {
            manageUserHrDetails,
            manageUserHrDetailsForm,
            ...translation
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, hrDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(ApproverDetails);